module.exports = __webpack_public_path__ + "img/lutim.png";